export default {
  collectionTable: {
    title: 'Collection Table',
    id: 'Id',
    tableName: 'Table name',
    tableTitle: 'Table title',
    allowDisplayCollection: 'Allow display collection',
    allowDisplayTopology: 'Allow display topology',
    allowSearch: 'Allow search',
    allowUpload: 'Allow upload',
    allowInsert: 'Allow insert',
    allowUpdate: 'Allow update',
    allowDelete: 'Allow delete',
    addItem: 'Add collection table',
    editItem: 'edit collection table'
  }
}